import type { ProductSearch } from './queries'

/** The catalog filters a search carries: storefront facet values, as the facets return them. */
export type ProductFilterState = {
  manufacturers: string[]
  categories: string[]
  /** Specification facets as `spec.<key>=<value>`. */
  facets: string[]
  /** Store price range in dollars; empty means open-ended. */
  minPrice: string
  maxPrice: string
}

export const emptyProductFilters: ProductFilterState = {
  manufacturers: [],
  categories: [],
  facets: [],
  minPrice: '',
  maxPrice: '',
}

const priceValue = (value: string) => {
  const number = Number(value)
  return value.trim() !== '' && Number.isFinite(number) && number >= 0 ? number : undefined
}

export function productFilterSearch(filters: ProductFilterState): Partial<ProductSearch> {
  return {
    manufacturer: filters.manufacturers.length ? filters.manufacturers : undefined,
    category: filters.categories.length ? filters.categories : undefined,
    facet: filters.facets.length ? filters.facets : undefined,
    min_price: priceValue(filters.minPrice),
    max_price: priceValue(filters.maxPrice),
  }
}

export function activeFilterCount(filters: ProductFilterState) {
  const price = priceValue(filters.minPrice) !== undefined || priceValue(filters.maxPrice) !== undefined ? 1 : 0
  return filters.manufacturers.length + filters.categories.length + filters.facets.length + price
}
